import { render, staticRenderFns } from "./EpotInputSoal.vue?vue&type=template&id=e1cfc39a"
import script from "./EpotInputSoal.vue?vue&type=script&lang=js"
export * from "./EpotInputSoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports